export const rankingListRoutes = {
  path: '',
  name: 'RankingList',
  component: () => import('@/views/ranking/index.vue'),
  meta: {
    hidden: false,
    title: 'Ranking List'
  }
}



